import React, { useState, useEffect, useRef } from "react";
import { BrowserRouter } from "react-router-dom";
import AppRoutes from "./Variations/AppRoutes";
import AppRoutes2 from "./Variations/AppRoutes2";
import SelectProjectPage from "./Variations/SelectProjectPage";
import PublicRoutes from "./Variations/PublicRoutes";
import SideBar from "./Variations/SideBar";
import SideBar2 from "./Variations/SideBar2";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Util from "./Classes/Util";
import { Variables } from "./Variations/Variations";
import "./Styles.css";
import Notifier from "react-desktop-notification";

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const [permissions, setPermissions] = useState({});
  const [notifications, setNotifications] = useState([]);
  const newNotifications = useRef([]);
  const [contactUs, setContactUs] = useState([]);
  const newContactUs = useRef([]);
  const [project, setProject] = useState(
    localStorage.getItem("active_project")
  );

  const CheckLoginToken = async () => {
    //fetch
    let response = await fetch(Variables.API_URL + "User/CheckUserLoginToken", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email: Util.decrypt(localStorage.getItem("Email")),
        token: Util.decrypt(localStorage.getItem("LoginToken")),
      }),
    });
    let result = await response.json();
    if (response.status === 200) {
      localStorage.setItem("Email", Util.encrypt(result.Email));
      localStorage.setItem("LoginToken", Util.encrypt(result.LoginToken));
      localStorage.setItem("Permissions", Util.encrypt(result.Permissions));
      localStorage.setItem("UserId", Util.encrypt(result.UserId));
      localStorage.setItem("UserName", Util.encrypt(result.UserName));

      setPermissions(Util.decrypt(localStorage.getItem("Permissions")));
      setIsAuthenticated(true);
    } else {
      localStorage.clear()
      setIsAuthenticated(false);
    }
  };

 

  const SendNotification = (Notifications, Length) => {
    for (let index = 0; index < Length; index++) {
      Notifier.start(
        Notifications[index].Title,
        Notifications[index].Body,
        "notification",
        "https://api.smallinsize.com/Uploads/Images/07_05_2022/bae1c853-b4af-48a2-b371-5022ad02da19.png"
      );
    }
  };
  const SendContactUs = (Notifications, Length) => {
    for (let index = 0; index < Length; index++) {
      Notifier.start(
        Notifications[index].Title,
        Notifications[index].Body,
        "ContactUs",
        "https://api.smallinsize.com/Uploads/Images/07_05_2022/bae1c853-b4af-48a2-b371-5022ad02da19.png"
      );
    }
  };
  useEffect(() => {
     const GetNotifications = async () => {
    let offset = new Date().getTimezoneOffset();
    const response = await fetch(
      Variables.API_URL + "Notification/GetNotificationsWithTypes/" + offset,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": Variables.API_URL,
        },
      }
    );
    let result = await response.json();
    setNotifications(result);
    if (
      newNotifications.current.length !== 0 &&
      result.length !== newNotifications.current.length
    )
      SendNotification(result, result.length - newNotifications.current.length);
    newNotifications.current = result;
    setTimeout(() => {
      GetNotifications();
    }, 7000);
  };
  const GetContactUs = async () => {
    let offset = new Date().getTimezoneOffset();
    const response = await fetch(
      Variables.API_URL + "Notification/GetContactUsMessages/" + offset,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": Variables.API_URL,
        },
      }
    );
    let result = await response.json();
    setContactUs(result);
    if (
      newContactUs.current.length !== 0 &&
      result.length !== newContactUs.current.length
    )
      SendContactUs(result, result.length - newContactUs.current.length);
    newContactUs.current = result;
    setTimeout(() => {
      GetContactUs();
    }, 10000);
  };
    if ("Email" in localStorage && "LoginToken" in localStorage) {
      CheckLoginToken();
      GetNotifications();
      GetContactUs();
    } else {
      setIsAuthenticated(false);
    }
  }, [isAuthenticated]);
useEffect(() => {
  // Sync project state with localStorage
  const storedProject = localStorage.getItem("active_project");
  setProject(storedProject);
}, [isAuthenticated]);

  return (
    <div className="App rasha-admin">
      <BrowserRouter>
        {isAuthenticated === true && project === "gazelle" && (
          <React.Fragment>
            <SideBar
              setIsAuthenticated={setIsAuthenticated}
              permissions={permissions}
              notifications={notifications}
              setNotifications={setNotifications}
              contactUs={contactUs}
              setContactUs={setContactUs}
            />
            <AppRoutes
              isAuthenticated={isAuthenticated}
              setIsAuthenticated={setIsAuthenticated}
              notifications={notifications}
              setNotifications={setNotifications}
              contactUs={contactUs}
              setContactUs={setContactUs}
            />
          </React.Fragment>
        )}
        {isAuthenticated === true && project === "rasha" && (
          <React.Fragment>
            <SideBar2
              setIsAuthenticated={setIsAuthenticated}
              permissions={permissions}
              notifications={notifications}
              setNotifications={setNotifications}
              contactUs={contactUs}
              setContactUs={setContactUs}
            />
            <AppRoutes2
              isAuthenticated={isAuthenticated}
              setIsAuthenticated={setIsAuthenticated}
              notifications={notifications}
              setNotifications={setNotifications}
              contactUs={contactUs}
              setContactUs={setContactUs}
            />
          </React.Fragment>
        )}
        {isAuthenticated === true && !project && <SelectProjectPage />}

        {isAuthenticated === false && (
          <React.Fragment>
            <PublicRoutes
              isAuthenticated={isAuthenticated}
              setIsAuthenticated={setIsAuthenticated}
            />
          </React.Fragment>
        )}
      </BrowserRouter>

      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
      />
    </div>
  );
}
// else{
//   return(
//     <div>
//       <h1>You are not Authorized</h1>
//     </div>
//   )
// }
// }

export default App;
